import { defineStore } from "pinia";
import useUtils from "@/Composables/useUtils";
import useRotas from '@/Composables/useRotas';

const route = useRotas();

const { mergeDeep } = useUtils();

export const useAuditorioStore = defineStore("auditorio", {
    state: () => {
        return {
            lotes: {},
            leiloes: {},
            idLoteSelecionadoLeilao: {},
            mensagens: [],
            processed: new Set(),
            ultimaAtualizacao: 0,
            processando: false,
            pararProcessamento: false,
        };
    },
    actions: {
        async carregamentoLeilaoInicial(idLeilao) {

            const leilao = await (
                await fetch(route('auditorio.dadosLeilaoAuditorio', {
                    idLeilao: idLeilao,
                }), {
                    method: "GET",
                    credentials: "include",
                })
            ).json();
            this.leiloes[leilao.id] = leilao;
        },
        async carregamentoLotesInicial(idLeilao) {

            const lotes = await (
                await fetch(route('auditorio.dadosLotesAuditorio', {
                    idLeilao: idLeilao,
                }), {
                    method: "GET",
                    credentials: "include",
                })
            ).json();

            lotes.forEach((lote) => {
                this.lotes[lote.id] = lote;

            });
        },
        async carregamentoLoteMomentoInicial(idLeilao, idLote) {

            const lote = await (
                await fetch(route('auditorio.dadosLoteMomentoAuditorio', { idLeilao: idLeilao, idLote: idLote }), {
                    method: "GET",
                    credentials: "include",
                })
            ).json();

            this.lotes[lote.id] = lote;
            this.idLoteSelecionadoLeilao[lote.id_leilao] = lote.id;

        },

        /**
         * Injeta os dados do lote recebidos pelo payload do WebSocket diretamente no store,
         * eliminando por completo a necessidade de um fetch HTTP para dadosLoteMomentoAuditorio.
         * Isso resolve o efeito "Thundering Herd": ao invés de 300 clientes fazerem 300 requisições
         * HTTP simultâneas, todos recebem os dados pelo WebSocket broadcast do Pusher/Soketi.
         */
        carregarLoteDoWebSocket(dadosLote) {
            if (dadosLote && dadosLote.id) {
                this.lotes[dadosLote.id] = dadosLote;
                this.idLoteSelecionadoLeilao[dadosLote.id_leilao] = dadosLote.id;
            }
        },

        redefinirLoteSelecionado(idLeilao) {
            this.idLoteSelecionadoLeilao[idLeilao] = null;
        },

        carregarLeilao(leilao) {
            this.leiloes[leilao.id] = leilao;
        },
        atualizarLeilao(leilao) {
            this.leiloes[leilao.id] = mergeDeep(
                this.leiloes[leilao.id],
                leilao
            );
        },

        carregarLote(lote) {
            this.lotes[lote.id] = lote;
        },
        atualizarLote(lote) {
            this.lotes[lote.id] = mergeDeep(
                this.lotes[lote.id],
                lote
            );
        },

        carregarOuAtualizar(mensagem) {
            console.log('inicio atualizacao', this.lotes[mensagem.id]);
            if (mensagem.tipo === "lote") {
                if (this.lotes[mensagem.id]) {
                    this.atualizarLote(mensagem.dados);
                } else {
                    this.carregarLote(mensagem.dados);
                }
            } else if (mensagem.tipo === "leilao") {
                if (this.leiloes[mensagem.id]) {
                    this.atualizarLeilao(mensagem.dados);
                } else {
                    this.carregarLeilao(mensagem.dados);
                }
            } else if (mensagem.tipo === "statusLote") {
                this.lotes[mensagem.id].status_lote = mensagem.status;
                this.lotes[mensagem.id].proximoStatus = mensagem.proximoStatus;
            } else if (mensagem.tipo === "statusLeilao") {
                this.leiloes[mensagem.id].status_leilao = mensagem.status;
                this.leiloes[mensagem.id].proximoStatus = mensagem.proximoStatus;
            }
            console.log('final atualizacao', this.lotes[mensagem.id]);
        },
        enfileirar(mensagem) {
            // Aceita mensagem se for mais recente ou se não tivermos processado nenhuma ainda
            // Permite processar mensagens que chegam fora de ordem mas com timestamp válido
            if (mensagem.timestamp >= this.ultimaAtualizacao || this.ultimaAtualizacao === 0) {
                console.log("Enfileirando", mensagem.messageId);
                this.mensagens.push(mensagem);
                // Ordena mensagens por timestamp para garantir ordem correta
                this.mensagens.sort((a, b) => a.timestamp - b.timestamp);
            } else {
               console.log("Descartando (Timestamp antigo)", mensagem.messageId, mensagem.timestamp, this.ultimaAtualizacao);
            }
        },
        async processar() {
            if (!this.pararProcessamento) {
                // Processa até 5 mensagens em batch para melhor performance
                const batchSize = 5;
                let processedInBatch = 0;

                while (processedInBatch < batchSize && this.mensagens.length > 0 && !this.pararProcessamento) {
                    const mensagem = this.mensagens.shift();
                    if (mensagem) {
                        const messageId = mensagem.messageId;
                        if (!this.processed.has(messageId)) {
                            console.log("Processando", messageId, mensagem);
                            this.carregarOuAtualizar(mensagem);
                            // Atualiza timestamp apenas se for mais recente
                            if (mensagem.timestamp > this.ultimaAtualizacao) {
                                this.ultimaAtualizacao = mensagem.timestamp;
                            }
                            this.processed.add(messageId);
                            processedInBatch++;

                            const size = this.processed.size;
                            console.log("Itens processados", size);
                            if (size > 10) {
                                const toRemove = size - 10;
                                console.log(
                                    "Limpando itens processados",
                                    size,
                                    toRemove
                                );
                                for (let i = 0; i < toRemove; i += 1) {
                                    this.processed.delete(
                                        this.processed.keys().next().value
                                    );
                                }
                            }
                        } else {
                            console.log("Descartando (Duplicada)", messageId);
                        }
                    }
                }

                // Delay reduzido de 200ms para 10ms - apenas para não bloquear a UI
                // Se não houver mensagens, aumenta o delay para economizar recursos
                const delay = this.mensagens.length > 0 ? 10 : 50;
                await new Promise((resolve) => setTimeout(resolve, delay));
                await this.processar();
            }
        },
        async processarFila() {
            console.log("Iniciando Processamento");
            if (!this.processando) {
                this.processando = true;
                this.pararProcessamento = false;
                await this.processar();
            }
        },
        pararFila() {
            console.log("Parando Processamento");
            this.pararProcessamento = true;
            this.processando = false;
            this.ultimaAtualizacao = 0;
            this.mensagens = [];
            this.processed = new Set();
            this.lotes = {};
            this.leiloes = {};
        },
    },
});
